<template>

            <v-card-text class="pt-10">
    <v-layout row wrap>
        <v-flex md6>                
                <v-card flat class="slider-card">
                    <div><span>Price</span> {{priceRange.value[0] + "-" + priceRange.value[1]}}</div>
                    <v-range-slider
                        v-model="priceRange.value"
                        step="10"
                    ></v-range-slider>
                </v-card>
        </v-flex>     
        <v-flex md6>                
                <v-card flat class="slider-card">
                    <div><span>Flight Duration</span></div>
                    <v-range-slider
                        v-model="priceRange.value"
                        step="10"
                        ticks
                    ></v-range-slider>
                </v-card>
        </v-flex>       
        <v-flex md6>                
                <v-card flat class="slider-card">
                    <div><span>Departing Time</span></div>                    
                    <v-range-slider             
                        v-model="priceRange.value"
                        step="10"
                        ticks
                    ></v-range-slider>
                </v-card>
        </v-flex>     
        <v-flex md6>                
                <v-card flat class="slider-card">
                    <div><span>Returning Time</span></div>       
                    <v-range-slider                 
                        v-model="priceRange.value"
                        step="10"
                        ticks
                    ></v-range-slider>
                </v-card>
        </v-flex>                 
    </v-layout>                
            </v-card-text> 

  
</template>

<script>
export default {
    data(){
        return {
            priceRange:{
                value:[0,7000],
                rules:[
                    v=> v <=7000 ||'Only 40 in stock'
                ]
            }
        }
    }
}
</script>

<style>
.slider-card{
    padding-left:10px;
    padding-right:10px;
}
.slider-card div span{
    font-weight: bold;
}
</style>
